/**
 * Brand mark and the artwork used by the auth screens' hero panel.
 *
 * Both are shipped as real assets (`src/assets`) rather than drawn inline —
 * the wordmark is the actual MindPeer logo, and the hero panel is a
 * photograph, not an approximation of one.
 */
import { cn } from '@/lib/format';
import logo from '@/assets/mindpeer-logo.png';
import heroPhoto from '@/assets/mindpeer-hero.jpg';

/* --------------------------- Brand lockup -------------------------- */

/** Mark plus wordmark, with the product tagline underneath. */
export function BrandLockup({ className }: { className?: string }) {
  return (
    <div className={className}>
      <img src={logo} alt="MindPeer" className="h-14 w-auto" />
      <p className="mt-3 text-sm text-slate-400">Decision Intelligence Workspace</p>
    </div>
  );
}

/* ----------------------------- Hero art ---------------------------- */

/** The photograph behind the auth screens' right-hand panel. */
export function HeroScene({ className }: { className?: string }) {
  return <img src={heroPhoto} alt="" aria-hidden="true" className={cn('object-cover', className)} />;
}
